/* eslint-disable react/jsx-one-expression-per-line */
/* eslint-disable max-lines-per-function */
import React from 'react'
import { useHookstate } from '@hookstate/core'
import {
  Badge,
  Box,
  Button,
  Collapse,
  Grid,
  IconButton,
  Stack,
  Typography,
} from '@mui/material'
import ExpandLess from '@mui/icons-material/ExpandLess'
import ExpandMore from '@mui/icons-material/ExpandMore'
import { useLang } from '~/hooks/useLang'
import useSurveillanceReportingState from '../../stores/SurveillanceReportingState'
import VideoMonitoringCards from '../VideoMonitoringCards'
import VideoMonitoringFilters from './components/FiltersVideoMonitoring'

export default function VideoMonitoringList() {
  const { translate } = useLang()
  const { surveillanceReportingStates } = useSurveillanceReportingState()
  const {
    showCheckbox,
    reports,
    isAssociateMode,
    save,
    searchDispatches,
    searchOccurrence,
    createOccurrence,
    isEditMode,
    selectedReportsForAssociation,
    surveillanceReporting,
  } = surveillanceReportingStates()
  const showFilters = useHookstate(true)
  const invalidRequest = useHookstate(false)
  const filterCount = useHookstate(0)
  const [height, setHeight] = React.useState(400)

  React.useEffect(() => {
    const showFiltersValue = showFilters.get()
    setHeight(showFiltersValue ? 400 : 700)
  }, [showFilters])

  React.useEffect(() => {
    if (reports.get().length === 0) {
    }
  }, [])

  const checkLenght = () => {
    return reports.get().filter((report) => report.checked).length
  }

  const finishAssociate = () => {
    reports.forEach((report) =>
      report.set((prev) => ({ ...prev, checked: false }))
    )
    
    showCheckbox.set(false)
    isAssociateMode.set(false)
    isEditMode.set(false)
    save.set(false)
    invalidRequest.set(false)
    
    searchOccurrence.set('')
    searchDispatches.set('')
    createOccurrence.set(false)
    selectedReportsForAssociation.set([])
    
    const { notes, cameraId, reportedAt, id, occurrenceId, typeId, subtypeId } = surveillanceReporting
    notes.set('')
    cameraId.set(null)
    reportedAt.set(null)
    id.set(undefined)
    occurrenceId.set(null)
    typeId.set(null)
    subtypeId.set(null)
  }



  return (
    <Grid
      container
      direction="row"
      sx={{
        display: 'flex',
        alignItems: 'flex-start',
        paddingBottom: 2,
      }}
    >
      <Grid item xs={12} sx={{ padding: '0px 8px' }}>
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
          pb={1}
        >
          <Typography
            variant="h6"
            component="h2"
            sx={{ flexGrow: 1, fontSize: '1rem', fontWeight: 400 }}
          >
            {translate('Filters')}
          </Typography>
          <Badge badgeContent={filterCount.get()} invisible={filterCount.get() === 0} color="primary">
            <IconButton
              onClick={() => showFilters.set(!showFilters.get())}
              size="small"
              sx={{ ml: 1 }}
            >
              {showFilters.get() ? <ExpandLess /> : <ExpandMore />}
            </IconButton>
          </Badge>
        </Stack>
          <Collapse 
          in={showFilters.get()}
          timeout={300}
          sx={{ '& .MuiCollapse-wrapper': { transition: 'transform 0.3s cubic-bezier(0.4, 0, 0.2, 1)' } }}
        >
          <VideoMonitoringFilters onSearch={() => { }} onFilterCountChange={(count) => filterCount.set(count)} />
        </Collapse>
        <Box sx={{ 
          height, 
          transition: 'height 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
          overflow: 'hidden'
        }}>
          <VideoMonitoringCards height={height} />
        </Box>
      </Grid>

      {showCheckbox.get() && (
        <Grid item xs={12}>
          <Collapse in={showCheckbox.get()}>
            <Grid
              container
              direction="row"
              sx={{
                paddingTop: 2,
                ml: 1,
                display: 'flex',
                alignItems: 'center',
                flexDirection: 'row',
                justifyContent: 'flex-start',
              }}
            >
              <Grid item>
                <Button variant="outlined" onClick={finishAssociate}>
                  {`${translate('Cancel')} - ${checkLenght()} ${translate(
                    'Selected'
                  )}${checkLenght() > 1 ? 's' : ''}`}
                </Button>
              </Grid>
            </Grid>
          </Collapse>
        </Grid>
      )}
    </Grid>
  )
}
